export enum ModalResponseEnum {
  CANCEL = 'cancel',
  SUCCESS = 'success',
  SAVE = 'save',
}
